import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Chip, Avatar } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const BrandsTableRow = ({
    brand,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng.startsWith('ar');

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            selected={isSelected}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, brand.id)}
                />
            </TableCell>

            {/* الرقم التسلسلي */}
            <TableCell align="start">{index + 1}</TableCell>

            {/* Logo */}
            <TableCell align="center">
                <Avatar
                    src={brand.logo?.preview_url}
                    alt={brand.name?.en}
                    variant="rounded"
                    sx={{ width: 40, height: 40, mx: 'auto', bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}
                >
                    {brand.name?.en?.charAt(0) || 'B'}
                </Avatar>
            </TableCell>

            {/* Names */}
            <TableCell align="start">
                <Typography variant="body2" fontWeight="medium">
                    {brand.name?.en || '-'}
                </Typography>
            </TableCell>

            <TableCell align="start">
                <Typography variant="body2">
                    {brand.name?.ar || '-'}
                </Typography>
            </TableCell>

            {/* Slug */}
            <TableCell align="start">
                <Chip
                    label={brand.slug}
                    size="small"
                    variant="outlined"
                    sx={{ fontFamily: 'monospace' }}
                />
            </TableCell>

            {/* Status */}
            <TableCell align="center">
                <Chip
                    label={brand.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    color={brand.is_active ? 'success' : 'error'}
                    size="small"
                    sx={{ borderRadius: '6px', minWidth: '70px' }}
                />
            </TableCell>

            {/* Created At */}
            <TableCell align="start" sx={{ whiteSpace: 'nowrap' }}>
                <Typography variant="caption" sx={{ fontSize: 'inherit' }}>
                    {brand.created_at ? dayjs(brand.created_at).format('YYYY-MM-DD') : '-'}
                </Typography>
            </TableCell>

            {/* Actions */}
            <TableCell align="right">
                <IconButton onClick={(event) => onMenuOpen(event, brand)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default BrandsTableRow;
